import { Project } from '../query-hooks/gray-projects';

export const buildAddress = (project: Project) =>
  [
    [project.street?.name, project.houseNumber].filter(Boolean).join(' '),
    project.neighborhood?.name,
    project.city?.name,
  ]
    .filter(Boolean)
    .join(', ');
